import {ReactNode, createContext } from "react";
import  { User } from "./auth";

export interface Message {
    role: "ai" | "human";
    text: string;
    timestamp?: string;
    message?:string;
  }
  

export interface Chat {
  id: number;
  session_id: number;
  messages: Message[];
}
  
export interface AppContextType {
  lastMsg: React.RefObject<HTMLDivElement>;
  messageText: string;
  setMessageText: (text: string) => void;
  processing: boolean;
  setProcessing: (processing: boolean) => void;
  messages: Message[];
  user: User | null;
  setUser: (user: User | null) => void;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  activeChat: number | null;
  setActiveChat: (chatId: any) => void;
  chats: Chat[];
  setChats: React.Dispatch<React.SetStateAction<Chat[]>>;
  isLoading: boolean;
  handleSubmission: () => Promise<void>;
  handleRegenerate: () => Promise<void>;
  error: string | null;
  }
  
export interface AppProviderProps {
    children: ReactNode;
  }
  
  // Create the context with an initial undefined value
export const AppContext = createContext<AppContextType | undefined>(undefined);

